// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text[data-v-90fc63ee]{font-family:Montserrat,\"system-ui\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-weight:400;font-size:1rem;--text-opacity:1;color:#333;color:rgba(51,51,51,var(--text-opacity));letter-spacing:0}", ""]);
// Exports
module.exports = exports;
